import { useSelector } from "react-redux";

// Components
import ProviderNavigation from "components/molecules/ProviderNavigation";

// Selectors
import * as gamesSelector from "redux/game/selectors";
import { useSettingsStore } from "stores/settings";

const ProviderNavigationContainer = () => {
  const filter = useSelector(gamesSelector.filter);
  const isSidebarOpen = useSettingsStore((state) => state.isSidebarOpen);
  const openSidebar = useSettingsStore((state) => state.openSidebar);

  const menuOpenHandler = () => {
    openSidebar();
  };

  return (
    <ProviderNavigation
      filter={filter}
      isSidebarOpen={isSidebarOpen}
      // eslint-disable-next-line react/jsx-handler-names
      onClick={menuOpenHandler}
    />
  );
};

export default ProviderNavigationContainer;
